export const LANDING = "/";
export const HOME = "/home";
export const HTIMELINE = "/htimeline";
export const SIGN_UP = "/signup";
export const SIGN_IN = "/signin";
export const SIGN_OUT = "/signout";
export const ACCOUNT = "/account";
export const ADMIN = "/admin";
export const PASSWORD_FORGET = "/pw-forget";
export const PASSWORD_CHANGE = "/pw-change";
